var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vks-assoc-filters" }, [
    _vm.activeFilterCount > 1
      ? _c("div", { staticClass: "vks-assoc-filter-reset-row" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-sm vks-assoc-filter-reset",
              attrs: { type: "button" },
              on: { click: _vm.clearAllFilters },
            },
            [_vm._v(" Clear all filters ")]
          ),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "vks-assoc-filter-columns" },
      _vm._l(_vm.filterGroups, function (group) {
        return _c(
          "section",
          { key: group.id, staticClass: "vks-assoc-filter-column" },
          [
            _c("h4", { staticClass: "vks-assoc-filter-column-title" }, [
              _vm._v(_vm._s(group.label)),
            ]),
            _vm._l(group.filters, function (filter) {
              return _c(
                "div",
                {
                  key: filter.field,
                  staticClass: "vks-assoc-filter-field",
                  class: {
                    "is-checkbox":
                      filter.type === "checkbox" || filter.type === "boolean",
                  },
                },
                [
                  _vm.showFieldLabel(group, filter)
                    ? _c("div", { staticClass: "vks-assoc-filter-label" }, [
                        _vm._v(" " + _vm._s(filter.label) + " "),
                      ])
                    : _vm._e(),
                  filter.type === "search" ||
                  filter.type === "search lower than" ||
                  filter.type === "search greater than"
                    ? [
                        _c("input", {
                          staticClass: "form-control vks-assoc-filter-input",
                          attrs: {
                            type: "text",
                            id: _vm.inputId(filter.field),
                            list:
                              filter.type === "search"
                                ? _vm.datalistId(filter.field)
                                : null,
                          },
                          domProps: { value: _vm.textFilterValue(filter) },
                          on: {
                            change: function ($event) {
                              return _vm.onFilterInput($event, filter)
                            },
                          },
                        }),
                        filter.type === "search"
                          ? _c(
                              "datalist",
                              { attrs: { id: _vm.datalistId(filter.field) } },
                              _vm._l(
                                _vm.searchSuggestions(filter.field),
                                function (option) {
                                  return _c("option", {
                                    key: `${filter.field}-${option}`,
                                    domProps: { value: option },
                                  })
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                      ]
                    : filter.type === "checkbox"
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "vks-assoc-filter-checkboxes",
                            attrs: {
                              role: "group",
                              "aria-label": filter.label,
                            },
                          },
                          [
                            _vm._l(
                              _vm.checkboxOptions(filter.field),
                              function (option) {
                                return _c(
                                  "label",
                                  {
                                    key: `${filter.field}-${_vm.optionValue(
                                      option
                                    )}`,
                                    staticClass: "vks-assoc-filter-check",
                                  },
                                  [
                                    _c("input", {
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: _vm.isCheckboxSelected(
                                          filter.field,
                                          _vm.optionValue(option)
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.onCheckboxToggle(
                                            filter,
                                            _vm.optionValue(option),
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.optionLabel(option))),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            !_vm.checkboxOptions(filter.field).length
                              ? _c(
                                  "p",
                                  { staticClass: "vks-assoc-filter-empty" },
                                  [_vm._v(" No options available. ")]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    : filter.type === "boolean"
                    ? [
                        _c("label", { staticClass: "vks-assoc-filter-check" }, [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: _vm.isBooleanSelected(filter.field),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onBooleanToggle(filter, $event)
                              },
                            },
                          }),
                          _c("span", [_vm._v(_vm._s(filter.label))]),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }